import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6diqgb3p: FaireBrandEntity = {
  token: "b_6diqgb3p",
  type: "brand",
  name: "Sophie la Girafe by Calisson Toys.",
  avatarUrl: "https://cdn.faire.com/fastly/c50b47f0cf90356eaa39fdad2f10984aa02195702b8e257de0b66d6d7bf0b6e2.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/9e664ff07b6c843f7ef68bf95b64867b8ca3faa3932687943effc5ec35bf5bb9.png",
  logoUrl: "https://cdn.faire.com/fastly/c50b47f0cf90356eaa39fdad2f10984aa02195702b8e257de0b66d6d7bf0b6e2.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/9e664ff07b6c843f7ef68bf95b64867b8ca3faa3932687943effc5ec35bf5bb9.png",
  location: "San Juan Capistrano, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 120,
  isTopShop: true,
  isInsider: true,
  description: "Even after 60 years, Sophie La Girafe hasn’t aged in the slightest.  Since her birth in 1961, Sophie has sold over 50 million units and continues to be the undisputed star for babies around the world. With widespread popularity, she still is genuinely loved by parents and children alike.  Sophie’s simple wonder has traveled from generation to generation and will remain your child’s timeless friend.\n\n The detail is important to us. From our natural rubber material, design, user experience, and even introducing more eco-friendly packaging, we strive to make Sophie the obvious choice for your baby.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:32:29.429Z",
    importedBy: "entity-db-cli"
  }
};
